import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Reveal, Eyebrow } from "@/components/site/Motion";
import { EMAIL } from "@/lib/api";

const FAQS = [
  ["How can you eliminate my transaction fees?", "We offer fee elimination programs that are fully compliant and easy for customers to understand. Your account manager will walk you through which setup fits your business best."],
  ["Is the equipment really free?", "Yes, for qualifying merchants. We'll review your business during your free quote and let you know which terminals or POS systems you qualify for."],
  ["Will I have one person to talk to?", "Always. Every merchant gets a dedicated account manager who knows your business, plus access to our tech support and customer service teams."],
  ["What does transparent pricing mean?", "No hidden fees, no confusing statements. Everything is explained up front before you sign anything."],
  ["How long does it take to switch?", "Most merchants are set up quickly. We handle the heavy lifting, from paperwork to getting your equipment ready."],
];

export const FAQ = () => (
  <section id="faq" className="bg-white px-4 py-24 sm:px-6 lg:px-12 lg:py-32" data-testid="faq-section">
    <div className="mx-auto grid max-w-7xl gap-12 lg:grid-cols-12">
      <Reveal className="lg:col-span-5">
        <Eyebrow>Questions</Eyebrow>
        <h2 className="mt-4 font-display text-4xl font-extrabold leading-[1.02] tracking-tight sm:text-5xl">Straight answers. No fine print games.</h2>
        <p className="mt-6 text-emerald-950/75">Still curious? Email <a href={`mailto:${EMAIL}`} className="font-semibold text-emerald-700 underline decoration-lime-400 decoration-2 underline-offset-4" data-testid="faq-email-link">{EMAIL}</a></p>
      </Reveal>
      <Reveal delay={0.1} className="lg:col-span-7">
        <Accordion type="single" collapsible defaultValue="item-0" className="space-y-3">
          {FAQS.map(([q, a], i) => (
            <AccordionItem key={i} value={`item-${i}`} className="rounded-2xl border border-emerald-900/10 bg-[#EAF3FF]/60 px-6 data-[state=open]:bg-[#EAF3FF]">
              <AccordionTrigger data-testid={`faq-trigger-${i}`} className="py-5 text-left font-display text-lg font-bold hover:no-underline">{q}</AccordionTrigger>
              <AccordionContent className="pb-5 text-[15px] leading-relaxed text-emerald-950/80">{a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
